import { useFloating, size, autoUpdate } from '@floating-ui/react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useDrawer = /* @__PURE__ */ __name(({
  isDrawerOpen,
  setIsDrawerOpen
}) => {
  const { context, floatingStyles, refs } = useFloating({
    open: isDrawerOpen,
    onOpenChange: setIsDrawerOpen,
    strategy: "fixed",
    placement: "right-start",
    middleware: [
      size({
        apply: ({ elements, rects }) => {
          Object.assign(elements.floating.style, {
            height: `${rects.reference.height}px`
          });
        }
      })
    ],
    whileElementsMounted: autoUpdate
  });
  return {
    refs,
    floatingStyles,
    context
  };
}, "useDrawer");

export { useDrawer };
//# sourceMappingURL=use-drawer.js.map
